import { ConditionService } from '../../../../shared/condition.service';

export class ConditionTreeController implements ng.IController {
  /* tslint:disable */
  $onInit = () => {};
  /* tslint:enable */

  /* @ngInject */
  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private ConditionService: ConditionService
  ) {
    if (this.$scope.isRoot && this.$scope.conditions) {
      this.updateGroupNames();
      let handler = this.$rootScope.$on('updateGroupNames', () => this.updateGroupNames());
      let editHandler = this.$rootScope.$on('editCondition', (event, condition, isEditing) => {
        if (this.$scope.isEditing === isEditing) {
          this.$scope.isChildEditing = true;
        }
      });
      let abortHandler = this.$rootScope.$on('stopEditing', (event, isSubCondition) => {
        if (this.$scope.isEditing === isSubCondition) {
          this.$scope.isChildEditing = false;
        }
      });
      this.$scope.$on('$destroy', handler);
      this.$scope.$on('$destroy', editHandler);
      this.$scope.$on('$destroy', abortHandler);
    }
  }

  dropCondition(event, index, condition, conditions) {
    if (index !== -1) {
      let dragStartIndex = this.$scope.models.dragStartIndex;
      let dragEndIndex = index - 1;
      if (conditions === this.$scope.models.dragStartConditions && dragEndIndex <= dragStartIndex) {
        dragStartIndex = dragStartIndex + 1;
      }
      conditions.splice(dragEndIndex, 0, condition);
      this.$scope.models.dragStartConditions.splice(dragStartIndex, 1);
      if (condition['@type'] === 'AndCondition' || condition['@type'] === 'OrCondition') {
        this.$rootScope.$emit('updateGroupNames');
      }
      return true;
    }
  }

  dragOver(event, index) {
    return index !== 0;
  }

  dragStart(index, conditions) {
    this.$scope.models.dragStartIndex = index;
    this.$scope.models.dragStartConditions = conditions;
  }

  private updateGroupNames() {
    this.$scope.conditions.forEach((c) => this.ConditionService.addGroupNames(c));
  }
}
